var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 268,
    viewBox: "0 0 376 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.281 97.5331L365.817 56.6116L317.376 29.6519L250.439 69.0899",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.44 69.0903L249.371 69.7191",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M247.285 70.9468L210.814 92.4355",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10,
    strokeDasharray: "3.77 3.77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M209.771 93.0491L208.701 93.6779L209.774 94.2992",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.898 95.5229L253.321 119.406",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10,
    strokeDasharray: "3.77 3.77"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.383 120.016L255.456 120.637L256.529 120.016",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M258.746 118.729L293.097 98.7988",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10,
    strokeDasharray: "3.77 3.77"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M294.209 98.155L295.282 97.5337",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M208.701 236.052L255.455 263.008L365.817 198.983L317.376 172.027L208.701 236.052Z",
    stroke: "#231F20",
    strokeWidth: 1.23879,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M208.969 236.052L255.723 263.008L366.081 198.983L317.644 172.027L208.969 236.052Z",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M255.455 191.316V263.008",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M316.953 29.6519V172.026",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M365.754 56.5601V198.931",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M208.701 166.292V235.582",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M208.701 93.2107V166.292",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10,
    strokeDasharray: "3.77 3.77"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3665 108.264C99.0202 108.264 108.467 98.8171 108.467 87.1634C108.467 75.5097 99.0202 66.0625 87.3665 66.0625C75.7128 66.0625 66.2656 75.5097 66.2656 87.1634C66.2656 98.8171 75.7128 108.264 87.3665 108.264Z",
    fill: "#F8EB30"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M241.214 191.647L250.439 196.96L250.42 222.124L241.029 216.521L241.214 191.647Z",
    stroke: "white",
    strokeWidth: 0.621279,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M228.155 183.853L237.38 189.166L237.361 214.333L227.971 208.731L228.155 183.853Z",
    stroke: "white",
    strokeWidth: 0.621279,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M215.64 176.078L224.865 181.391L224.846 206.558L215.455 200.955L215.64 176.078Z",
    stroke: "white",
    strokeWidth: 0.621279,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M241.214 222.124L250.439 227.44L250.42 252.604L241.029 247.001L241.214 222.124Z",
    stroke: "white",
    strokeWidth: 0.621279,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M228.155 214.333L237.38 219.646L237.361 244.81L227.971 239.207L228.155 214.333Z",
    stroke: "white",
    strokeWidth: 0.621279,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M215.64 206.558L224.865 211.871L224.846 237.035L215.455 231.432L215.64 206.558Z",
    stroke: "white",
    strokeWidth: 0.621279,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M274.491 181.085L255.999 191.749L212.352 166.427L231.51 155.764L274.491 181.085Z",
    fill: "#F8EB30"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M292.506 145.533L274.011 156.197L230.363 130.871L249.521 120.211L292.506 145.533Z",
    fill: "#F8EB30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10 43.4063C12.5265 43.4063 238.412 169.323 238.412 169.323L352.874 5",
    stroke: "#F8EB30",
    strokeWidth: 1.23879,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M255.453 191.749V263.008",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M255.453 120.637V191.749",
    stroke: "white",
    strokeWidth: 2.48135,
    strokeMiterlimit: 10,
    strokeDasharray: "3.77 3.77"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.ea5e27fe4048aacc3cf8db1d15210a54.svg";
export { ForwardRef as ReactComponent };